module.exports = __webpack_public_path__ + "img/hr-heated-t-up-1.e78ec38f.png";